import React from 'react';
import './App.css';
import {HashRouter as Router,Route,Switch} from 'react-router-dom'
import Rmaform from './Rmaform'
import ViewRmaform from './ViewRmaform'
import EditRmaform from './EditRmaform'
import CompleteRmaform from './CompleteRmaform'
import PhotoGallery from './PhotoGallery'

function App() {
  return (
    <div className="App">
      <Router >
       <Switch>
          <Route exact path='/'>
          <Rmaform /> 
          </Route>
          <Route  path='/view' component={ViewRmaform} />
            
          <Route  path='/edit/:cid' component={EditRmaform} />
          <Route  path='/complete/:cid' component={CompleteRmaform} />
          <Route  path='/photo' component={PhotoGallery} />
          </Switch>
          </Router>
    </div>
  );
}

export default App;
